<template>
  <v-container>
    <v-row v-if="staticContent == null">
      <v-col sm="12">
        <v-skeleton-loader class="mx-auto" type="card"></v-skeleton-loader>
      </v-col>
    </v-row>
    <v-row v-if="staticContent != null">
      <v-col sm="12" md="10">
        <v-row>
          <v-col sm="12">
            <h2 class="text-h2">
              {{ staticContent.title }}
            </h2>
          </v-col>
        </v-row>

        <v-row>
          <v-col sm="12">
            <div v-html="staticContent.content"></div>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import APIAdapter from "../store/APIAdapter";

export default {
  components: {},

  metaInfo: {
    title: "", // zatim bez titulku, protoze neumim nastavit title dynamicky pres this.$meta().setOptions({})
  },

  data() {
    return {
      staticContent: null,
    };
  },

  async mounted() {
    console.log("mounted -- checkout-contacts");
    this.loadStaticContent();
  },

  watch: {
    $route() {
      this.loadStaticContent();
    },
  },

  computed: {
    staticContentId() {
      return this.$route.params.staticContentId;
    },
  },

  methods: {
    async loadStaticContent() {
      console.log("loadStaticContent -- ID:");
      console.log(this.staticContentId);
      this.staticContent = null;
      if (this.staticContentId != null) {
        this.staticContent = await APIAdapter.getStaticContent(
          this.staticContentId
        );
        console.log("nacteno:");
        console.log(this.staticContent);
      } else {
        console.log("nasrat:");
        this.staticContent = null;
      }
    },
  },
};
</script>
